module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_vm._v("Text copyright © 2016 by Denise Gee."), _c('br'), _vm._v("Photographs copyright © 2016 by Robert M. Peacock.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4521-3700-1 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4521-3296-9 (hc)")]), _vm._v(" "), _c('p', [_vm._v("Designed by Stitch Design Co."), _c('br'), _vm._v("Food and prop styling by Denise Gee")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "font1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Permissions")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter07#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 31")]), _vm._v(": Emeril’s Tomato Jam used with permission from Chef Emeril Lagasse.")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter21#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 60")]), _vm._v(": Oysters Rockefeller Spinach Dip adapted from "), _c('em', [_vm._v("The Cooking Club Cookbook")]), _vm._v(" (Villard) with permission from author Katherine Fausset and Random House.")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter50#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 115")]), _vm._v(": Pascal’s Manale BBQ Shrimp adapted from a recipe shared by New Orleans restaurant Pascal’s Manale, used with their permission.")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/xhtml/62chapter51#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 116")]), _vm._v(": Dickie Brennan’s Oyster Pan Roast used with permission from Chef Dickie Brennan of The Palace Café in New Orleans.")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/xhtml/68chapter56#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 126")]), _vm._v(": Stanley’s Juleps used with permission from author Stanley Dry.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aea04c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05copyright.vue
// module id = 69
// module chunks = 0